import React from "react";
import { IonChip, IonIcon, IonLabel, IonSpinner } from "@ionic/react";
import { Link, useLocation } from "react-router-dom";
import { IconCategory } from "../../pages/Pictures/PictureCard";
import { useCategories } from "../../pages/Pictures/useCategories";
import { informationCircle } from "ionicons/icons";

export const CategorieLinks = () => {
  const { pathname } = useLocation();
  const { categories, findCategoryById, selectCategory, categoryName } =
    useCategories();

  return (
    <div className="ion-text-center">
      <Link
        to={{ pathname: `/slike/svi` }}
        style={{ textDecoration: "none", color: "var(--ion-color-dark)" }}
        target="_self"
        onClick={() => selectCategory(findCategoryById(0))}
      >
        <IonChip>
          <IconCategory category={0} />
          <IonLabel>{categoryName(0)}</IonLabel>
        </IonChip>
      </Link>
      <Link
        to={{ pathname: `/slike/akcija` }}
        style={{ textDecoration: "none", color: "var(--ion-color-dark)" }}
        target="_self"
        onClick={() => selectCategory(findCategoryById(-1))}
      >
        <IonChip>
          <IconCategory category={-1} />
          <IonLabel>{categoryName(-1)}</IonLabel>
          <div
            style={{
              backgroundColor: "var(--ion-color-danger)",
              borderRadius: 3,
              color: "#fff",
              fontWeight: 600,
              fontSize: "12px",
              lineHeight: "20px",
              marginLeft: "8px",
              padding: "0 5px",
            }}
          >
            %
          </div>
        </IonChip>
      </Link>
      {pathname !== "/kako-poruciti" && (
        <Link
          to={{ pathname: `/kako-poruciti` }}
          style={{ textDecoration: "none", color: "var(--ion-color-dark)" }}
          target="_self"
          onClick={() => selectCategory(findCategoryById(0))}
        >
          <IonChip>
            <IonIcon icon={informationCircle} />
            <IonLabel>Kako poručiti</IonLabel>
          </IonChip>
        </Link>
      )}
      <br />
      {categories.map((c) => (
        <Link
          key={c.id}
          to={{ pathname: `/slike/${findCategoryById(c.id).code}` }}
          style={{ textDecoration: "none", color: "var(--ion-color-dark)" }}
          target="_self"
          onClick={() => selectCategory(findCategoryById(c.id))}
        >
          <IonChip>
            <IconCategory category={c.id} />
            <IonLabel>{categoryName(c.id)}</IonLabel>
          </IonChip>
        </Link>
      ))}
      {categories.length === 0 && <IonSpinner style={{ paddingTop: 60 }} />}
    </div>
  );
};
